import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';

import { apiEndpoint } from '@/app/app/constants/endpoints.const';
import { VersionInfo } from '@/app/app/interfaces/app/version-info';

@Service()
export class SupportVersionApi {
  http = inject(HttpClient);

  public getSupportVersion(): Observable<VersionInfo> {
    return this.http.get<VersionInfo>(`${apiEndpoint}/supported-versions`);
  }

}
